import { MockedResponse } from '@apollo/client/testing';
import type { FetchResult } from '@apollo/client';
import type { AutoShipChurnPreventionOfferModule } from '../../../types/definitions/vendor/graphql-schema.d';
import { GetAutoShipChurnPreventionOfferDocument, type GetAutoShipChurnPreventionOfferQuery } from './GetAutoShipChurnPreventionOffer';
import { AcceptAutoShipChurnPreventionOfferDocument, type AcceptAutoShipChurnPreventionOfferMutation } from './AcceptAutoShipChurnPreventionOffer';
export const getAutoShipChurnPreventionOfferMock = (offerId = '20_off_next_fix') => ({
  data: {
    client: {
      autoShipChurnPreventionOfferModule: {
        offerId,
        name: 'AUTO_SHIP_CHURN_PREVENTION_OFFER_MODULE',
        productTrackingEventName: 'autoship_cancellation_intervention_promo',
        declineProductTrackingEventName: 'decline_autoship_cancellation_promo_offer_button',
        declineProductTrackingEventActionName: 'decline_autoship_cancellation_promo_offer',
        acceptProductTrackingEventName: 'accept_autoship_cancellation_promo_offer_button',
        acceptProductTrackingEventActionName: 'accept_autoship_cancellation_promo_offer',
        headline: 'Get 20% off your next Fix',
        description: 'Don’t miss out on personalized style, straight to your door.',
        acceptCtaLabel: 'Accept offer',
        declineCtaLabel: 'No, I still want to cancel'
      } as AutoShipChurnPreventionOfferModule
    }
  }
}) satisfies FetchResult<GetAutoShipChurnPreventionOfferQuery>;
export const getAutoShipChurnPreventionOfferResponse = (offerId?: string): MockedResponse<GetAutoShipChurnPreventionOfferQuery> => ({
  request: {
    query: GetAutoShipChurnPreventionOfferDocument,
    variables: {}
  },
  result: getAutoShipChurnPreventionOfferMock(offerId)
});
export const acceptAutoShipChurnPreventionOfferMock = ({
  offerId = '20_off_next_fix',
  succeeds = true
}: {
  offerId?: string;
  succeeds?: boolean;
} = {}): MockedResponse<AcceptAutoShipChurnPreventionOfferMutation> => ({
  request: {
    query: AcceptAutoShipChurnPreventionOfferDocument,
    variables: {
      input: {
        offerId
      }
    }
  },
  result: {
    data: {
      __typename: 'Mutation',
      acceptAutoShipChurnPreventionOffer: {
        __typename: 'AcceptAutoShipChurnPreventionOfferPayload',
        result: succeeds ? {
          __typename: 'AcceptAutoShipChurnPreventionOfferSuccess'
        } : {
          __typename: 'AcceptAutoShipChurnPreventionOfferError',
          code: 'DISCOUNT_NOT_ASSIGNED',
          message: 'Unable to accept offer'
        }
      }
    }
  } satisfies FetchResult<AcceptAutoShipChurnPreventionOfferMutation>
});